import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Button, CircularProgress, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { showNotification } from 'store/actions/notifications';
import { NOTIFICATION_TYPE_ERROR, NOTIFICATION_TYPE_SUCCESS } from 'constants/notification';
import * as api from './api';
import Etiqueta from './Etiqueta';

// Painel da proposta dinâmica (24/10/2026): vendedor vê as suas;
// coordenador e master veem todas. Reaberturas, tempo de leitura e
// "chegou ao valor" ficam só aqui (o Pipedrive recebe só 1ª abertura e aceite).

const useStyles = makeStyles((theme) => ({
  pagina: { maxWidth: 1440, margin: '0 auto', padding: '20px 16px 64px' },
  kpis: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 16, [theme.breakpoints.up('md')]: { gridTemplateColumns: 'repeat(4,1fr)' } },
  kpi: { padding: '12px 14px', borderRadius: 12, border: '1px solid #E4E3E9' },
  kpiRot: { display: 'block', color: '#64688B', fontSize: 12, letterSpacing: '.06em', textTransform: 'uppercase', fontWeight: 700 },
  kpiVal: { display: 'block', fontSize: 26, fontWeight: 900, lineHeight: 1.1, marginTop: 4 },
  kpiSub: { fontSize: 12, color: '#64688B' },
  grade: { display: 'grid', gridTemplateColumns: '1fr', gap: 16, [theme.breakpoints.up('lg')]: { gridTemplateColumns: 'minmax(0,2fr) minmax(300px,1fr)', alignItems: 'start' } },
  tabela: { overflowX: 'auto', border: '1px solid #E4E3E9', borderRadius: 12, background: '#fff' },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13.5, minWidth: 720, '& th': { textAlign: 'left', fontSize: 11, letterSpacing: '.08em', textTransform: 'uppercase', color: '#64688B', padding: '10px 12px', borderBottom: '1px solid #E4E3E9' }, '& td': { padding: '10px 8px', borderBottom: '1px solid #E4E3E9', verticalAlign: 'middle', fontVariantNumeric: 'tabular-nums' }, '& tbody tr': { cursor: 'pointer' }, '& tbody tr:hover td': { background: '#E8F5EA' } },
  sel: { '& td': { background: '#E8F5EA' } },
  detalhe: { padding: 16, borderRadius: 12, border: '1px solid #E4E3E9' },
  linhaTempo: { listStyle: 'none', margin: 0, padding: 0, borderLeft: '2px solid #E4E3E9', marginLeft: 6, '& li': { position: 'relative', padding: '0 0 12px 16px', fontSize: 13.5 }, '& li::before': { content: '""', position: 'absolute', left: -7, top: 5, width: 10, height: 10, borderRadius: '50%', background: '#1F9833', border: '2px solid #fff' }, '& time': { display: 'block', fontSize: 12, color: '#64688B' } },
  pipe: { marginTop: 14, border: '1px solid #E4E3E9', borderRadius: 10, padding: '10px 12px', background: '#F9F8F9', fontSize: 13.5 },
  acoes: { display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 },
  filtros: { display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'flex-end', marginBottom: 12 },
}));

const ROTULO_EVENTO = {
  aberta: (e) => `${e.ordem}ª abertura${e.aparelho ? ` · ${e.aparelho}` : ''}${e.segundos ? ` · ${api.tempo(e.segundos)} de leitura` : ''}${e.ordem > 1 && e.primeira_do_aparelho ? ' · aparelho novo' : ''}`,
  chegou_ao_valor: () => 'Chegou ao valor',
  pdf: () => 'Abriu o PDF / imprimiu',
  clique_fechar: () => 'Clicou em "Quero fechar" (abriu o WhatsApp)',
  vencida: () => 'Abriu depois de vencida (viu o aviso)',
};

function Painel({ notify }) {
  const classes = useStyles();
  const history = useHistory();
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [status, setStatus] = useState('');
  const [busca, setBusca] = useState('');
  const [sel, setSel] = useState(null);
  const [det, setDet] = useState(null);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const d = await api.listar({ status: status || undefined, busca: busca || undefined });
      setDados(d);
      if (!sel && d.propostas.length) setSel(d.propostas[0].id);
    } catch (e) {
      notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e));
    } finally {
      setCarregando(false);
    }
    // eslint-disable-next-line
  }, [status, busca]);

  useEffect(() => { carregar(); }, [carregar]);
  useEffect(() => {
    if (!sel) return;
    setDet(null);
    api.detalhe(sel).then(setDet).catch((e) => notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e)));
    // eslint-disable-next-line
  }, [sel]);

  const acao = async (fn, msg) => {
    try {
      const r = await fn();
      setDet(r);
      notify(NOTIFICATION_TYPE_SUCCESS, msg);
      carregar();
    } catch (e) {
      notify(NOTIFICATION_TYPE_ERROR, api.mensagemDoErro(e));
    }
  };

  const k = (dados && dados.kpis) || {};
  const pct = (a, b) => (b ? `${Math.round((a / b) * 100)}%` : '—');

  return (
    <div className={classes.pagina}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 12, flexWrap: 'wrap' }}>
        <Typography variant="h5" style={{ fontWeight: 900 }}>{dados && dados.coordenador ? 'Propostas da equipe' : 'Minhas propostas'}</Typography>
        <Button component={Link} to="/propostas/nova" variant="contained" color="primary" size="small" style={{ marginLeft: 'auto' }}>Nova proposta</Button>
      </div>
      <p style={{ color: '#64688B', margin: '4px 0 16px' }}>Cada linha é um link enviado; clique para ver a linha do tempo e o que foi para o Pipedrive.</p>

      <div className={classes.kpis}>
        <Paper elevation={0} className={classes.kpi}><span className={classes.kpiRot}>Enviadas</span><b className={classes.kpiVal}>{k.enviadas || 0}</b><span className={classes.kpiSub}>{k.aguardando_aprovacao ? `${k.aguardando_aprovacao} aguardando aprovação` : 'nesta lista'}</span></Paper>
        <Paper elevation={0} className={classes.kpi}><span className={classes.kpiRot}>Abertas pelo cliente</span><b className={classes.kpiVal}>{k.abertas || 0}</b><span className={classes.kpiSub}>{pct(k.abertas, k.enviadas)} das enviadas</span></Paper>
        <Paper elevation={0} className={classes.kpi}><span className={classes.kpiRot}>Aceitas</span><b className={classes.kpiVal}>{k.aceitas || 0}</b><span className={classes.kpiSub}>{api.brl(k.honorarios_aceitas || 0)} em honorários</span></Paper>
        <Paper elevation={0} className={classes.kpi}><span className={classes.kpiRot}>Tempo de leitura</span><b className={classes.kpiVal}>{api.tempo(k.mediana_segundos)}</b><span className={classes.kpiSub}>mediana · {pct(k.chegaram_ao_valor, k.abertas)} chegam ao valor</span></Paper>
      </div>

      <form className={classes.filtros} onSubmit={(e) => { e.preventDefault(); carregar(); }}>
        <TextField select label="Status" value={status} onChange={(e) => setStatus(e.target.value)} style={{ minWidth: 200 }}>
          <MenuItem value="">Todos</MenuItem>
          {Object.keys(api.STATUS).map((s) => <MenuItem key={s} value={s}>{api.STATUS[s].rotulo}</MenuItem>)}
        </TextField>
        <TextField label="Cliente, nº, PT ou negócio" value={busca} onChange={(e) => setBusca(e.target.value)} />
        <Button type="submit" variant="outlined">Filtrar</Button>
        {carregando && <CircularProgress size={20} />}
      </form>

      <div className={classes.grade}>
        <div className={classes.tabela}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>Cliente</th><th>Plano</th><th>Honorários</th><th>Enviada</th><th>1ª abertura</th><th>Aberturas</th><th>Tempo</th><th>Último acesso</th><th>Status</th>
              </tr>
            </thead>
            <tbody>
              {dados && dados.propostas.map((p) => (
                <tr key={p.id} className={p.id === sel ? classes.sel : ''} onClick={() => setSel(p.id)}>
                  <td><b>{p.cliente || '—'}</b><br /><small style={{ color: '#64688B' }}>nº {p.numero}{dados.coordenador && p.vendedor ? ` · ${p.vendedor.nome}` : ''}</small></td>
                  <td>{p.plano}{p.requerentes ? ` · ${p.requerentes} req.` : ''}</td>
                  <td>{p.honorarios !== null ? api.brl(p.honorarios) : '—'}</td>
                  <td>{api.dataHora(p.enviada_em) || '—'}</td>
                  <td>{p.primeira_abertura ? api.dataHora(p.primeira_abertura) : <span style={{ color: '#64688B' }}>ainda não</span>}</td>
                  <td>{p.aberturas}</td>
                  <td>{api.tempo(p.segundos)}</td>
                  <td>{api.dataHora(p.ultimo_acesso) || '—'}</td>
                  <td><Etiqueta status={p.status} /></td>
                </tr>
              ))}
              {dados && !dados.propostas.length && (
                <tr><td colSpan={9} style={{ color: '#64688B' }}>Nenhuma proposta ainda. Abra uma pelo campo "Link proposta" do negócio no Pipedrive.</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <Paper elevation={0} className={classes.detalhe}>
          {!det && <span style={{ color: '#64688B' }}>{sel ? 'Carregando…' : 'Escolha uma proposta.'}</span>}
          {det && (
            <>
              <h3 style={{ margin: '0 0 2px', fontSize: 16 }}>{det.proposta.cliente}</h3>
              <div style={{ color: '#64688B', fontSize: 13, marginBottom: 12 }}>
                Proposta nº {det.proposta.numero} · {det.proposta.plano} · honorários {api.brl(det.proposta.honorarios)}
                {' · '}<a href={`https://cidadaniaja.pipedrive.com/deal/${det.proposta.negocio}`} target="_blank" rel="noopener noreferrer">negócio {det.proposta.negocio}</a>
                {det.proposta.validade_ate ? ` · validade ${api.data(det.proposta.validade_ate)}` : ''}
              </div>
              <ul className={classes.linhaTempo}>
                {det.proposta.enviada_em && <li>Link gerado e publicado<time>{api.dataHora(det.proposta.enviada_em)}</time></li>}
                {det.linha_do_tempo.map((e, i) => (
                  <li key={i}>{(ROTULO_EVENTO[e.tipo] || (() => e.tipo))(e)}{e.versao ? <small style={{ color: '#64688B' }}>{` · versão ${e.versao}`}</small> : null}<time>{api.dataHora(e.em)}</time></li>
                ))}
                {!det.linha_do_tempo.length && <li>O cliente ainda não abriu.</li>}
              </ul>
              <div className={classes.pipe}>
                <b style={{ fontSize: 12, letterSpacing: '.08em', textTransform: 'uppercase', color: '#64688B' }}>O que foi para o Pipedrive e Slack</b>
                <ul style={{ margin: '6px 0 0', paddingLeft: 18 }}>
                  {det.proposta.enviada_em && <li>Atividade "Proposta enviada" (concluída, com o link)</li>}
                  {det.proposta.primeira_abertura ? <li>Atividade "Proposta aberta pelo cliente" + nota · DM no Slack</li> : <li style={{ color: '#9A6700' }}>A 1ª abertura cria a atividade "Proposta aberta pelo cliente"</li>}
                  {det.proposta.aceita_em && <li>Atividade "Proposta aceita: ligar" (vence em 1 h) + nota · DM no Slack</li>}
                </ul>
                {det.proposta.erro_integracao && <p style={{ color: '#DB0A3C', margin: '6px 0 0', fontSize: 12.5 }}>Último erro ao avisar o Pipedrive: {det.proposta.erro_integracao}</p>}
              </div>
              <div className={classes.acoes}>
                {det.proposta.link && <Button size="small" variant="outlined" href={`${det.proposta.link}#interno`} target="_blank" rel="noopener">Abrir</Button>}
                {det.proposta.link && <Button size="small" variant="outlined" onClick={() => navigator.clipboard && navigator.clipboard.writeText(det.proposta.link).then(() => notify(NOTIFICATION_TYPE_SUCCESS, 'Link copiado'))}>Copiar link</Button>}
                {det.proposta.link && <Button size="small" variant="outlined" onClick={() => acao(() => api.renovar(det.proposta.id), 'Validade renovada')}>Renovar validade</Button>}
                <Button size="small" variant="outlined" onClick={() => history.push(`/propostas/${det.proposta.id}/editar`)}>Nova versão</Button>
                {det.proposta.status === 'aguardando_aprovacao' && dados && dados.coordenador && (
                  <Button size="small" variant="contained" style={{ background: '#EE9E00' }} onClick={() => acao(() => api.aprovar(det.proposta.id), 'Desconto aprovado')}>Aprovar desconto ({String(det.versao_atual && det.versao_atual.calculo.honorarios.desconto_pct).replace('.', ',')}%)</Button>
                )}
              </div>
            </>
          )}
        </Paper>
      </div>
      <p style={{ fontSize: 12, color: '#64688B', marginTop: 8 }}>Reaberturas, tempo de leitura e "chegou ao valor" ficam só aqui. A primeira abertura e o "Quero fechar" vão ao Pipedrive, para poupar a cota diária.</p>
    </div>
  );
}

export default connect(null, { notify: showNotification })(Painel);
